import React from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './consoleLogin.css';

const ConsoleLogin = () => {
  return (
    <div className="console-login-page" aria-label="Loading">
      <div className="console-login-content">
        {/* Brand Logo */}
        <img
          src="/assets/CB_64x64_white.svg"
          alt="Clientbook"
          className="console-login-logo"
        />

        {/* Animated Spinner */}
        <div className="console-login-spinner">
          <FontAwesomeIcon
            icon={['far', 'spinner-third']}
            spin
            className="console-login-spinner-icon"
          />
        </div>

        {/* Primary Message */}
        <span className="console-login-message">Signing you in...</span>
      </div>
    </div>
  );
};

const mapStateToProps = state => state;
const mapDispatchToProps = dispatch => ({
  setAuth(account, token) {
    dispatch({
      type: 'SET_AUTH',
      payload: { account, token },
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ConsoleLogin);
